document.addEventListener('DOMContentLoaded', function(){



  const database =

    document.getElementById('az-card-database');



  if(!database) return;



  // Price-checker-only loading overlay; never affects the rest of Shopify.

  const azLoader = document.getElementById('az-tcg-loading-overlay');

  // Move the overlay out of the Shopify section and into the top-level body.
  // This prevents section wrappers, transforms and clipping from constraining it.
  if (azLoader) {
    document.body.appendChild(azLoader);
    Object.assign(azLoader.style, {
      position: 'fixed',
      inset: '0',
      top: '0',
      right: '0',
      bottom: '0',
      left: '0',
      width: '100vw',
      height: '100dvh',
      maxWidth: 'none',
      maxHeight: 'none',
      margin: '0',
      zIndex: '2147483647',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxSizing: 'border-box',
      overflowY: 'auto'
    });
    // Restore the stylesheet's fade-out behaviour rather than forcing display:none.
  }

  const azLoaderStatus = document.getElementById('az-tcg-loading-status');

  const azLoaderCounter = document.getElementById('az-tcg-loading-counter');
  const azExpectedTransactions = Number(database.dataset.transactionTotal || 0); // Live Shopify metaobject total from Liquid.
  function azUpdateTransactionCounter(loaded) {
    if (!azLoaderCounter || azLoaderDismissed) return;
    const current = Number(loaded) || 0;
    azLoaderCounter.textContent = azExpectedTransactions > 0
      ? current.toLocaleString('en-SG') + ' / ' + azExpectedTransactions.toLocaleString('en-SG') + ' transaction records'
      : current.toLocaleString('en-SG') + ' verified transactions loaded';
  }


  const azLoaderContinue = document.getElementById('az-tcg-loading-continue');

  let azLoaderDismissed = false;

  // Prevent background scrolling while the Price Checker loading screen is visible.
  // Preserve any existing inline overflow styles and restore them on dismissal.
  const azPreviousHtmlOverflow = document.documentElement.style.overflow;
  const azPreviousBodyOverflow = document.body.style.overflow;
  if (azLoader) {
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
  }


  function azSetLoaderStatus(message) {

    if (azLoaderStatus && !azLoaderDismissed) azLoaderStatus.textContent = message;

  }

  function azDismissLoader() {

    if (!azLoader || azLoaderDismissed) return;

    azLoaderDismissed = true;

    azLoader.classList.add('az-tcg-loader-done');

    azLoader.setAttribute('aria-hidden', 'true');

    // Keep scrolling locked through the fade-out, then restore the page.
    window.setTimeout(() => {
      azLoader.remove();
      document.documentElement.style.overflow = azPreviousHtmlOverflow;
      document.body.style.overflow = azPreviousBodyOverflow;
    }, 420);

  }

  if (azLoaderContinue) azLoaderContinue.addEventListener('click', azDismissLoader);

  const azLoaderLongWait = window.setTimeout(() => {

    if (!azLoaderDismissed && azLoaderContinue) {

      azSetLoaderStatus('This is taking longer than expected. You can continue browsing while prices load.');

      azLoaderContinue.hidden = false;

    }

  }, 25000);





  const grid =

    document.getElementById('az-card-grid');



  const heroSearch =

    document.getElementById('az-hero-search');



  const heroSearchButton =

    document.getElementById('az-hero-search-button');



  const search =

    document.getElementById('az-card-search');



  const gameFilter =

    document.getElementById('az-game-filter');



  const setFilter =

    document.getElementById('az-set-filter');



  const rarityFilter =

    document.getElementById('az-rarity-filter');



  const counter =

    document.getElementById('az-result-count');



  const totalCardCount =

    document.getElementById('az-total-card-count');



  const mlbbCount =

    document.getElementById('az-mlbb-count');



  const empty =

    document.getElementById('az-empty-state');



  const databaseSection =

    document.getElementById('az-database-section');





  /* =========================================================

     MODAL

  ========================================================= */



  const modal =

    document.getElementById('az-card-modal');



  const modalPanel =

    modal.querySelector('.az-modal-panel');



  const modalImage =

    document.getElementById('az-modal-image');



  const imageLoader =

    document.getElementById('az-image-loader');





  let cards = [];

  let storedScrollY = 0;

  let currentCardToken = 0;
  let azActiveCardData = null;




  /* =========================================================

     VERIFIED TRANSACTIONS - PAGINATED

  ========================================================= */



  let verifiedTransactions = [];
let azTransactionsState = 'loading';

function azSetCardPriceState(state) {
  document.querySelectorAll(
    '#az-card-grid .az-card-item'
  ).forEach(function(card) {
    const priceElement = card.querySelector(
      '.az-card-market-price'
    );

    if (!priceElement) return;

    const priceLabel = priceElement.parentElement
      ? priceElement.parentElement.querySelector('.az-small-label')
      : null;

    if (state === 'loading') {
      if (priceLabel) priceLabel.textContent = 'Market Price';
      priceElement.textContent = 'LOADING...';
      priceElement.classList.add('az-pending');
      priceElement.title = 'Verified transactions are loading';
    }

    if (state === 'error') {
      if (priceLabel) priceLabel.textContent = 'Market Price';
      priceElement.textContent = 'DATA UNAVAILABLE';
      priceElement.classList.add('az-pending');
      priceElement.title = 'Unable to load verified transactions';
    }
  });
}
  



  function readTransactionPage(doc) {

    const element = doc.getElementById('az-verified-transactions');

    if (!element) throw new Error('Transaction JSON missing from page');

    const items = JSON.parse(element.textContent);

    if (!Array.isArray(items)) throw new Error('Transaction JSON is not an array');

    const pagination = doc.getElementById('az-transaction-pagination');

    return {

      items,

      nextUrl: pagination ? pagination.dataset.nextUrl : ''

    };

  }



  async function loadVerifiedTransactions() {

    const seenPages = new Set();

    const byId = new Map();

    let page = readTransactionPage(document);

    let pagesLoaded = 0;

    azSetLoaderStatus('Retrieving verified transactions...');
    azUpdateTransactionCounter(0);



    while (true) {

      for (const item of page.items) {

        if (item && item.id) byId.set(String(item.id), item);

      }

      pagesLoaded++;

      azSetLoaderStatus('Loading verified transactions · ' + byId.size.toLocaleString() + ' records');
      azUpdateTransactionCounter(byId.size);

      if (!page.nextUrl) break;



      const url = new URL(page.nextUrl, window.location.href);

      if (seenPages.has(url.href)) {

        throw new Error('Transaction pagination loop detected');

      }

      seenPages.add(url.href);



      const response = await fetch(url.href, { credentials: 'same-origin' });

      if (!response.ok) throw new Error('Transaction page HTTP ' + response.status);

      const html = await response.text();

      const doc = new DOMParser().parseFromString(html, 'text/html');

      page = readTransactionPage(doc);

    }



    verifiedTransactions = Array.from(byId.values());
azTransactionsState = 'ready';

azUpdateTransactionCounter(verifiedTransactions.length);

    console.info('AZ TCG transactions loaded:', verifiedTransactions.length,

      'across', pagesLoaded, 'pages');

    updateCardGridMarketPrices();

    azSetLoaderStatus('Market prices are ready');

  }



  /* =========================================================

     RARITY ORDER

  ========================================================= */



  const rarityOrder = {

    'PR': 1,

    'SSP+': 2,

    'SSP': 3,

    'AR': 4,

    'QR': 5,

    'TR': 6,

    'LR': 7,

    'SP+': 8,

    'SP': 9,

    'UR+': 10,

    'UR': 11,

    'SSR+': 12,

    'SSR': 13,

    'RS': 14,

    'CS': 15,

    'R': 16,

    'C': 17

  };



  function normalizeRarity(value){



    return String(value || '')

      .trim()

      .toUpperCase()

      .replace(/\s+/g,'');



  }





  function getRarityRank(card){



    const rarity =

      normalizeRarity(

        card.dataset.rarity

      );



    return rarityOrder[rarity] || 999;



  }





  /* =========================================================

     SORT CARDS

  ========================================================= */



  function sortCards(){



    cards.sort(function(a,b){

      // Show MLBB Vol. 2 first, then Vol. 1.

      const setRank = function(card){

        const set = String(card.dataset.set || '').trim().toLowerCase();

        if (/vol\.?\s*2\b/.test(set)) return 0;

        if (/vol\.?\s*1\b/.test(set)) return 1;

        return 2;

      };

      const setDifference = setRank(a) - setRank(b);

      if (setDifference !== 0) return setDifference;



      // Within each set, follow the full rarity hierarchy.

      const rarityDifference = getRarityRank(a) - getRarityRank(b);

      if (rarityDifference !== 0) return rarityDifference;



      // Tie-break by card number, ascending.

      return String(a.dataset.number || '').localeCompare(

        String(b.dataset.number || ''),

        undefined,

        { numeric: true, sensitivity: 'base' }

      );

    });



    const fragment =

      document.createDocumentFragment();





    cards.forEach(function(card){



      fragment.appendChild(card);



    });





    grid.appendChild(fragment);



  }





  /* =========================================================

     COUNTS

  ========================================================= */



  function updateCounts(){



    if(totalCardCount){



      totalCardCount.textContent =

        cards.length;



    }





    if(mlbbCount){



      const mlbbCards =

        cards.filter(function(card){



          return (

            card.dataset.game || ''

          ).toLowerCase() ===

          'mobile legends';



        });





      mlbbCount.textContent =

        mlbbCards.length +

        ' Cards';



    }



  }





  /* =========================================================

     REFRESH CARDS

  ========================================================= */



  function refreshCards(){



    cards =

      Array.from(

        grid.querySelectorAll(

          '.az-card-item'

        )

      );





    cards.forEach(function(card){



      card.dataset.rarity =

        normalizeRarity(

          card.dataset.rarity

        );



    });





    sortCards();





    cards.forEach(function(card){



      bindCard(card);



    });





    updateCounts();



  }





  /* =========================================================

     CARD CLICK

  ========================================================= */



  function bindCard(card){



    if(card.dataset.bound === '1'){

      return;

    }





    card.dataset.bound =

      '1';





    card.addEventListener(

      'click',

      function(){



        openCard(card);



      }

    );





    card.addEventListener(

      'keydown',

      function(e){



        if(

          e.key === 'Enter' ||

          e.key === ' '

        ){



          e.preventDefault();



          openCard(card);



        }



      }

    );



  }





  /* =========================================================

     FILTERS

  ========================================================= */



  function runFilters(){



    const q =

      search.value

        .trim()

        .toLowerCase();





    const game =

      gameFilter.value

        .toLowerCase();





    const set =

      setFilter.value

        .toLowerCase();





    const rarity =

      normalizeRarity(

        rarityFilter.value

      );





    let visible = 0;





    cards.forEach(function(card){



      const searchable = (

        (card.dataset.name || '') +

        ' ' +

        (card.dataset.number || '')

      ).toLowerCase();





      const matchesSearch =

        !q ||

        searchable.includes(q);





      const matchesGame =

        game === 'all' ||

        (

          card.dataset.game || ''

        ).toLowerCase() === game;





      const matchesSet =

        set === 'all' ||

        (

          card.dataset.set || ''

        ).toLowerCase() === set;





      const cardRarity =

        normalizeRarity(

          card.dataset.rarity

        );





      const matchesRarity =

        rarity === 'ALL' ||

        cardRarity === rarity;





      const show =

        matchesSearch &&

        matchesGame &&

        matchesSet &&

        matchesRarity;





      card.style.display =

        show ? '' : 'none';





      if(show){

        visible++;

      }



    });





    if(counter){



      counter.textContent =

        visible +

        (

          visible === 1

            ? ' card'

            : ' cards'

        );



    }





    if(empty){



      empty.hidden =

        visible !== 0;



    }



  }





  /* =========================================================

     HERO SEARCH

  ========================================================= */



  function performHeroSearch(){



    const value =

      heroSearch

        ? heroSearch.value.trim()

        : '';





    search.value =

      value;





    gameFilter.value =

      'all';



    setFilter.value =

      'all';



    rarityFilter.value =

      'all';





    runFilters();





    databaseSection.scrollIntoView({

      behavior:'smooth',

      block:'start'

    });



  }





  if(heroSearchButton){



    heroSearchButton.addEventListener(

      'click',

      performHeroSearch

    );



  }





  if(heroSearch){



    heroSearch.addEventListener(

      'keydown',

      function(e){



        if(e.key === 'Enter'){



          performHeroSearch();



        }



      }

    );



  }





  /* =========================================================

     BROWSE BY GAME

  ========================================================= */



  document

    .querySelectorAll(

      '[data-game-select]'

    )

    .forEach(function(button){



      button.addEventListener(

        'click',

        function(){



          gameFilter.value =

            button.dataset.gameSelect;





          setFilter.value =

            'all';





          rarityFilter.value =

            'all';





          search.value =

            '';





          if(heroSearch){



            heroSearch.value =

              '';



          }





          runFilters();





          databaseSection.scrollIntoView({

            behavior:'smooth',

            block:'start'

          });



        }

      );



    });





  /* =========================================================

     DATE HELPERS

  ========================================================= */



  function dateTimestamp(value){



    if(!value){

      return 0;

    }





    const parsed =

      new Date(value);





    if(

      Number.isNaN(

        parsed.getTime()

      )

    ){

      return 0;

    }





    return parsed.getTime();



  }





  function formatDate(value){



    if(!value){

      return '—';

    }





    const date =

      new Date(value);





    if(

      Number.isNaN(

        date.getTime()

      )

    ){

      return value;

    }





    return date.toLocaleDateString(

      'en-SG',

      {

        day:'numeric',

        month:'short',

        year:'numeric'

      }

    );



  }





  function formatChartDate(value){



    const date =

      new Date(value);





    if(

      Number.isNaN(

        date.getTime()

      )

    ){

      return '';

    }





    return date.toLocaleDateString(

      'en-SG',

      {

        day:'numeric',

        month:'short'

      }

    );



  }





  function formatSGD(value){



    const number =

      Number(value);





    if(

      !Number.isFinite(number)

    ){

      return '—';

    }





    return (

      'S$' +

      number.toFixed(2)

    );



  }





  /* =========================================================

     GET SALES FOR CARD

  ========================================================= */



  function getSalesForCard(cardId){



    return verifiedTransactions

      .filter(function(transaction){



        return (

          String(transaction.cardId) ===

          String(cardId)

        );



      })

      .filter(function(transaction){



        return Number.isFinite(

          Number(transaction.price)

        );



      })

      .sort(function(a,b){



        return (

          dateTimestamp(b.date) -

          dateTimestamp(a.date)

        );



      });



  }





  /* =========================================================

     SVG HELPER

  ========================================================= */



  function createSVGElement(

    name,

    attributes

  ){



    const element =

      document.createElementNS(

        'http\://www.w3.org/2000/svg',

        name

      );





    Object.keys(

      attributes || {}

    ).forEach(function(key){



      element.setAttribute(

        key,

        attributes[key]

      );



    });





    return element;



  }





  /* =========================================================

     PRICE HISTORY CHART

  ========================================================= */



  function renderPriceChart(sales){



    const chart =

      document.getElementById(

        'az-price-chart'

      );





    if(!chart){

      return;

    }





    chart.innerHTML =

      '';





    /*

      Chart uses oldest → newest

    */



    const chartSales =

      sales

        .filter(function(sale){



          return (

            Number.isFinite(

              Number(sale.price)

            ) &&

            dateTimestamp(

              sale.date

            ) > 0

          );



        })

        .slice()

        .sort(function(a,b){



          return (

            dateTimestamp(a.date) -

            dateTimestamp(b.date)

          );



        });





    if(chartSales.length < 2){



      chart.hidden =

        true;



      return;



    }





    chart.hidden =

      false;





    /* =======================================================

       CHART DIMENSIONS

    ======================================================= */



    const width =

      640;



    const height =

      230;





    const padding = {

      top:22,

      right:20,

      bottom:38,

      left:55

    };





    const innerWidth =

      width -

      padding.left -

      padding.right;





    const innerHeight =

      height -

      padding.top -

      padding.bottom;





    /* =======================================================

       PRICE RANGE

    ======================================================= */



    const prices =

      chartSales.map(

        function(sale){



          return Number(

            sale.price

          );



        }

      );





    let minPrice =

      Math.min.apply(

        null,

        prices

      );





    let maxPrice =

      Math.max.apply(

        null,

        prices

      );





    /*

      Flat price history needs some vertical space

    */



    if(minPrice === maxPrice){



      const paddingAmount =

        Math.max(

          minPrice * .08,

          1

        );





      minPrice -=

        paddingAmount;





      maxPrice +=

        paddingAmount;



    }else{



      const range =

        maxPrice -

        minPrice;





      minPrice -=

        range * .12;





      maxPrice +=

        range * .12;



    }





    minPrice =

      Math.max(

        0,

        minPrice

      );





    /* =======================================================

       SVG

    ======================================================= */



    const svg =

      createSVGElement(

        'svg',

        {

          viewBox:

            '0 0 ' +

            width +

            ' ' +

            height,



          width:'100%',

          height:'auto',



          role:'img',



          'aria-label':

            'Verified sale price history'

        }

      );





    svg.classList.add(

      'az-chart-svg'

    );





    /* =======================================================

       GRID LINES

    ======================================================= */



    const gridCount =

      3;





    for(

      let i = 0;

      i < gridCount;

      i++

    ){



      const ratio =

        i /

        (gridCount - 1);





      const y =

        padding.top +

        ratio *

        innerHeight;





      const value =

        maxPrice -

        ratio *

        (

          maxPrice -

          minPrice

        );





      const line =

        createSVGElement(

          'line',

          {

            x1:padding.left,

            y1:y,

            x2:

              width -

              padding.right,

            y2:y,

            class:'az-chart-grid-line'

          }

        );





      svg.appendChild(

        line

      );





      const label =

        createSVGElement(

          'text',

          {

            x:

              padding.left -

              10,



            y:

              y + 4,



            'text-anchor':'end',



            class:

              'az-chart-axis-label'

          }

        );





      label.textContent =

        'S$' +

        value.toFixed(0);





      svg.appendChild(

        label

      );



    }





    /* =======================================================

       POINT POSITIONS

    ======================================================= */



    const points =

      chartSales.map(

        function(sale,index){



          const xRatio =

            chartSales.length === 1

              ? .5

              : index /

                (

                  chartSales.length -

                  1

                );





          const priceRatio =

            (

              Number(sale.price) -

              minPrice

            ) /

            (

              maxPrice -

              minPrice

            );





          return {



            x:

              padding.left +

              xRatio *

              innerWidth,



            y:

              padding.top +

              (

                1 -

                priceRatio

              ) *

              innerHeight,



            sale:sale



          };



        }

      );





    /* =======================================================

       LINE PATH

    ======================================================= */



    const pathData =

      points

        .map(

          function(point,index){



            return (

              (

                index === 0

                  ? 'M'

                  : 'L'

              ) +

              point.x +

              ' ' +

              point.y

            );



          }

        )

        .join(' ');





    const linePath =

      createSVGElement(

        'path',

        {

          d:pathData,

          class:'az-chart-line'

        }

      );





    svg.appendChild(

      linePath

    );





    /* =======================================================

       POINTS

    ======================================================= */



    points.forEach(

      function(point){



        const circle =

          createSVGElement(

            'circle',

            {

              cx:point.x,

              cy:point.y,

              r:5,

              class:'az-chart-point'

            }

          );





        const title =

          createSVGElement(

            'title'

          );





        title.textContent =

          formatSGD(

            point.sale.price

          ) +

          ' · ' +

          formatDate(

            point.sale.date

          );





        circle.appendChild(

          title

        );





        svg.appendChild(

          circle

        );



      }

    );





    /* =======================================================

       FIRST DATE

    ======================================================= */



    const firstDate =

      createSVGElement(

        'text',

        {

          x:padding.left,

          y:

            height -

            10,



          'text-anchor':'start',



          class:

            'az-chart-axis-label'

        }

      );





    firstDate.textContent =

      formatChartDate(

        chartSales[0].date

      );





    svg.appendChild(

      firstDate

    );





    /* =======================================================

       LAST DATE

    ======================================================= */



    const lastSale =

      chartSales[

        chartSales.length -

        1

      ];





    const lastDate =

      createSVGElement(

        'text',

        {

          x:

            width -

            padding.right,



          y:

            height -

            10,



          'text-anchor':'end',



          class:

            'az-chart-axis-label'

        }

      );





    lastDate.textContent =

      formatChartDate(

        lastSale.date

      );





    svg.appendChild(

      lastDate

    );





    /* =======================================================

       INTERACTIVE CROSSHAIR + TOOLTIP

       Desktop: hover

       Mobile: tap / drag

    ======================================================= */



    const crosshair =

      createSVGElement(

        'line',

        {

          x1:padding.left,

          y1:padding.top,

          x2:padding.left,

          y2:

            height -

            padding.bottom,

          stroke:'rgba(255,255,255,.42)',

          'stroke-width':'1',

          opacity:'0',

          'pointer-events':'none'

        }

      );





    svg.appendChild(

      crosshair

    );





    const focusPoint =

      createSVGElement(

        'circle',

        {

          cx:padding.left,

          cy:padding.top,

          r:'7',

          fill:'#ffffff',

          stroke:'#111111',

          'stroke-width':'2',

          opacity:'0',

          'pointer-events':'none'

        }

      );





    svg.appendChild(

      focusPoint

    );





    const interactionLayer =

      createSVGElement(

        'rect',

        {

          x:padding.left,

          y:padding.top,

          width:innerWidth,

          height:innerHeight,

          fill:'transparent',

          'pointer-events':'all'

        }

      );





    svg.appendChild(

      interactionLayer

    );





    chart.style.position =

      'relative';





    svg.style.touchAction =

      'none';





    const tooltip =

      document.createElement(

        'div'

      );





    tooltip.setAttribute(

      'aria-hidden',

      'true'

    );





    tooltip.style.position =

      'absolute';



    tooltip.style.zIndex =

      '5';



    tooltip.style.minWidth =

      '150px';



    tooltip.style.padding =

      '10px 12px';



    tooltip.style.borderRadius =

      '10px';



    tooltip.style.background =

      'rgba(18,18,20,.96)';



    tooltip.style.border =

      '1px solid rgba(255,255,255,.14)';



    tooltip.style.boxShadow =

      '0 8px 24px rgba(0,0,0,.32)';



    tooltip.style.pointerEvents =

      'none';



    tooltip.style.opacity =

      '0';



    tooltip.style.transform =

      'translateY(-50%)';



    tooltip.style.transition =

      'opacity .12s ease';



    tooltip.style.color =

      '#ffffff';



    tooltip.style.fontFamily =

      'Arial, Helvetica, sans-serif';





    const tooltipDate =

      document.createElement(

        'div'

      );





    tooltipDate.style.fontSize =

      '12px';



    tooltipDate.style.opacity =

      '.68';



    tooltipDate.style.marginBottom =

      '5px';





    const tooltipSale =

      document.createElement(

        'div'

      );





    tooltipSale.style.fontSize =

      '13px';



    tooltipSale.style.fontWeight =

      '600';





    tooltip.appendChild(

      tooltipDate

    );





    tooltip.appendChild(

      tooltipSale

    );



    const tooltipChange = document.createElement('div');

    tooltipChange.style.cssText = 'font-size:12px;font-weight:700;margin-top:5px;';

    tooltip.appendChild(tooltipChange);





    chart.appendChild(

      tooltip

    );





    function showChartPoint(index){



      const point =

        points[index];





      if(!point){

        return;

      }





      crosshair.setAttribute(

        'x1',

        point.x

      );



      crosshair.setAttribute(

        'x2',

        point.x

      );



      crosshair.setAttribute(

        'opacity',

        '1'

      );





      focusPoint.setAttribute(

        'cx',

        point.x

      );



      focusPoint.setAttribute(

        'cy',

        point.y

      );



      focusPoint.setAttribute(

        'opacity',

        '1'

      );





      tooltipDate.textContent =

        formatDate(

          point.sale.date

        );





      tooltipSale.textContent =

        'Verified Sale · ' +

        formatSGD(

          point.sale.price

        );



      const previous = index > 0 ? Number(points[index - 1].sale.price) : null;

      const current = Number(point.sale.price);

      const change = previous > 0 ? ((current - previous) / previous) * 100 : null;

      tooltipChange.textContent = change === null ? 'First recorded sale' :

        ((change > 0 ? '+' : '') + change.toFixed(1) + '% vs previous sale');

      tooltipChange.style.color = change === null ? '#a1a1aa' :

        change > 0 ? '#4ade80' : change < 0 ? '#fb7185' : '#a1a1aa';





      const svgBox =

        svg.getBoundingClientRect();





      const chartBox =

        chart.getBoundingClientRect();





      const scaledX =

        (

          point.x /

          width

        ) *

        svgBox.width;





      const scaledY =

        (

          point.y /

          height

        ) *

        svgBox.height;





      const pointLeft =

        (

          svgBox.left -

          chartBox.left

        ) +

        scaledX;





      const pointTop =

        (

          svgBox.top -

          chartBox.top

        ) +

        scaledY;





      const placeLeft =

        pointLeft >

        chartBox.width * .62;





      tooltip.style.left =

        placeLeft

          ? Math.max(

              8,

              pointLeft - 170

            ) + 'px'

          : Math.min(

              chartBox.width - 158,

              pointLeft + 12

            ) + 'px';





      tooltip.style.top =

        Math.max(

          44,

          Math.min(

            chartBox.height - 44,

            pointTop

          )

        ) + 'px';





      tooltip.style.opacity =

        '1';





      tooltip.setAttribute(

        'aria-hidden',

        'false'

      );



    }





    function hideChartPoint(){



      crosshair.setAttribute(

        'opacity',

        '0'

      );





      focusPoint.setAttribute(

        'opacity',

        '0'

      );





      tooltip.style.opacity =

        '0';





      tooltip.setAttribute(

        'aria-hidden',

        'true'

      );



    }





    function handleChartPointer(event){



      const rect =

        svg.getBoundingClientRect();





      const pointerX =

        (

          event.clientX -

          rect.left

        ) /

        rect.width *

        width;





      const clampedX =

        Math.max(

          padding.left,

          Math.min(

            width -

            padding.right,

            pointerX

          )

        );





      let nearestIndex =

        0;





      let nearestDistance =

        Infinity;





      points.forEach(

        function(point,index){



          const distance =

            Math.abs(

              point.x -

              clampedX

            );





          if(

            distance <

            nearestDistance

          ){



            nearestDistance =

              distance;



            nearestIndex =

              index;



          }



        }

      );





      showChartPoint(

        nearestIndex

      );



    }





    interactionLayer.addEventListener(

      'pointermove',

      function(event){



        handleChartPointer(

          event

        );



      }

    );





    interactionLayer.addEventListener(

      'pointerdown',

      function(event){



        interactionLayer.setPointerCapture(

          event.pointerId

        );





        handleChartPointer(

          event

        );



      }

    );





    interactionLayer.addEventListener(

      'pointerup',

      function(event){



        if(

          interactionLayer.hasPointerCapture(

            event.pointerId

          )

        ){



          interactionLayer.releasePointerCapture(

            event.pointerId

          );



        }



      }

    );





    interactionLayer.addEventListener(

      'pointerleave',

      function(event){



        if(

          event.pointerType === 'mouse'

        ){



          hideChartPoint();



        }



      }

    );





    chart.appendChild(

      svg

    );



  }





  /* =========================================================

     AZ TCG MARKET PRICE HELPERS

     Rule:

     - Use up to 10 most recent verified sales

     - Only sales from the last 90 days

     - Minimum 3 qualifying sales

     - Market Price = median

  ========================================================= */



  function getRecentMarketSales(sales){



    const now = Date.now();



    const ninetyDays =

      90 * 24 * 60 * 60 * 1000;



    return sales

      .filter(function(sale){



        const timestamp =

          dateTimestamp(sale.date);



        return (

          timestamp > 0 &&

          timestamp <= now &&

          (now - timestamp) <= ninetyDays &&

          Number.isFinite(

            Number(sale.price)

          )

        );



      })

      .slice(0,10);



  }





  function getMedianPrice(sales){



    const prices =

      sales

        .map(function(sale){

          return Number(sale.price);

        })

        .filter(function(price){

          return Number.isFinite(price);

        })

        .sort(function(a,b){

          return a - b;

        });





    if(!prices.length){

      return null;

    }





    const middle =

      Math.floor(

        prices.length / 2

      );





    if(prices.length % 2 === 1){

      return prices[middle];

    }





    return (

      prices[middle - 1] +

      prices[middle]

    ) / 2;



  }





  function updateCardGridMarketPrices(){
    cards.forEach(function(card){
      const cardId = card.dataset.cardId;
      const priceElement = card.querySelector('.az-card-market-price');
      if(!cardId || !priceElement) return;

      // The label sits beside the price in the existing Shopify card markup.
      const priceLabel = priceElement.parentElement
        ? priceElement.parentElement.querySelector('.az-small-label')
        : null;
      const sales = getSalesForCard(cardId);
      const marketSales = getRecentMarketSales(sales);
      const marketPrice = marketSales.length >= 3
        ? getMedianPrice(marketSales)
        : null;

      if(marketPrice !== null && Number.isFinite(Number(marketPrice))){
        if(priceLabel) priceLabel.textContent = 'Market Price';
        priceElement.textContent = formatSGD(marketPrice);
        priceElement.classList.remove('az-pending');
        priceElement.removeAttribute('title');
      }else if(sales.length){
        if(priceLabel) priceLabel.textContent = 'Last Verified Sale';
        priceElement.textContent = formatSGD(sales[0].price);
        priceElement.classList.remove('az-pending');
        priceElement.title = 'Last verified sale: ' + formatDate(sales[0].date);
      }else{
        if(priceLabel) priceLabel.textContent = 'No Sales Data';
        priceElement.textContent = '—';
        priceElement.classList.add('az-pending');
        priceElement.title = 'No verified transactions recorded';
      }
    });
  }


  /* =========================================================

     RENDER MARKET DATA

  ========================================================= */



  function renderMarketData(data){



    const sales =

      getSalesForCard(

        data.id

      );





    const marketSales =

      getRecentMarketSales(

        sales

      );





    const marketPrice =

      marketSales.length >= 3

        ? getMedianPrice(

            marketSales

          )

        : null;





    const price =

      document.getElementById(

        'az-modal-price'

      );





    const pendingCopy =

      document.getElementById(

        'az-market-pending-copy'

      );





    const priceStatus =

      document.getElementById(

        'az-price-status'

      );





    const rangeInline =

      document.getElementById(

        'az-market-range-inline'

      );





    const range =

      document.getElementById(

        'az-market-range'

      );





    const priceHistoryEmpty =

      document.getElementById(

        'az-price-history-empty'

      );





    const priceChart =

      document.getElementById(

        'az-price-chart'

      );





    const salesEmpty =

      document.getElementById(

        'az-sales-empty'

      );





    const recentSales =

      document.getElementById(

        'az-recent-sales'

      );





    const verifiedCount =

      document.getElementById(

        'az-verified-count'

      );





    const marketFooter =

      document.getElementById(

        'az-market-footer'

      );





    const lastUpdated =

      document.getElementById(

        'az-market-last-updated'

      );





    /* =======================================================

       RESET

    ======================================================= */



    rangeInline.hidden =

      true;





    priceHistoryEmpty.hidden =

      false;





    priceChart.hidden =

      true;





    priceChart.innerHTML =

      '';





    salesEmpty.hidden =

      false;





    recentSales.hidden =

      true;





    verifiedCount.hidden =

      true;





    marketFooter.hidden =

      true;





    recentSales.innerHTML =

      '';

    if (azTransactionsState !== 'ready') {
  price.textContent =
    azTransactionsState === 'loading'
      ? 'LOADING...'
      : 'DATA UNAVAILABLE';

  priceStatus.textContent =
    azTransactionsState === 'loading'
      ? 'Loading verified sales'
      : 'Market data unavailable';

  pendingCopy.textContent =
    azTransactionsState === 'loading'
      ? 'Verified transaction records are still loading. Prices will update automatically.'
      : 'Verified transactions could not be loaded. Please refresh the page to try again.';

  return;
}




    /* =======================================================

       MARKET PRICE



       AZ TCG methodology:

       - 3+ qualifying verified sales required

       - Up to 10 most recent sales

       - Sales must be within the last 90 days

       - Market Price = median of those sales



       Initial Benchmark is retained only as stored reference

       data and does not override verified-sale pricing.

    ======================================================= */



    if(

      marketPrice !== null &&

      Number.isFinite(

        Number(marketPrice)

      )

    ){



      price.textContent =

        formatSGD(

          marketPrice

        );





      pendingCopy.textContent =

        'Median of ' +

        marketSales.length +

        ' recent verified sales from the last 90 days.';





      priceStatus.textContent =

        'AZ TCG market price';



    }else if(sales.length){

      // No qualifying median yet: display the latest verified sale,
      // clearly distinguished from an AZ TCG Market Price.
      price.textContent = formatSGD(sales[0].price);
      priceStatus.textContent = 'Last Sold';
      pendingCopy.textContent = 'Last verified sale on ' + formatDate(sales[0].date) +
        '. Market Price requires at least 3 verified sales within the last 90 days' +
        ' (currently ' + marketSales.length + ').';

    }else{

      price.textContent = 'NO SALES DATA';
      priceStatus.textContent = 'No verified sales';
      pendingCopy.textContent = 'No verified sales have been recorded for this card yet.';

    }



    /* =======================================================

       NO VERIFIED SALES

    ======================================================= */



    if(

      sales.length === 0

    ){



      const historyTitle =

        priceHistoryEmpty.querySelector(

          'strong'

        );





      const historyCopy =

        priceHistoryEmpty.querySelector(

          'p'

        );





      if(historyTitle){



        historyTitle.textContent =

          'Not enough market data yet';



      }





      if(historyCopy){



        historyCopy.textContent =

          'Price history will appear once verified sales are recorded.';



      }





      return;



    }





    /* =======================================================

       VERIFIED SALES EXIST

    ======================================================= */



    salesEmpty.hidden =

      true;





    recentSales.hidden =

      false;





    verifiedCount.hidden =

      false;





    marketFooter.hidden =

      false;





    verifiedCount.textContent =

      sales.length +

      (

        sales.length === 1

          ? ' Sale'

          : ' Sales'

      );





    /* =======================================================

       TYPICAL RANGE

    ======================================================= */



    const prices =

      sales

        .map(function(sale){



          return Number(

            sale.price

          );



        })

        .filter(function(value){



          return Number.isFinite(

            value

          );



        });





    if(prices.length){



      const lowest =

        Math.min.apply(

          null,

          prices

        );





      const highest =

        Math.max.apply(

          null,

          prices

        );





      rangeInline.hidden =

        false;





      if(lowest === highest){



        range.textContent =

          formatSGD(lowest);



      }else{



        range.textContent =

          formatSGD(lowest) +

          ' – ' +

          formatSGD(highest);



      }



    }





    /* =======================================================

       RECENT VERIFIED SALES

       MOST RECENT 6

    ======================================================= */



    sales

      .slice(0,6)

      .forEach(function(sale){



        const row =

          document.createElement(

            'div'

          );





        row.className =

          'az-sale-row';





        const left =

          document.createElement(

            'div'

          );





        left.className =

          'az-sale-left';





        const salePrice =

          document.createElement(

            'strong'

          );





        salePrice.className =

          'az-sale-price';





        salePrice.textContent =

          formatSGD(

            sale.price

          );





        left.appendChild(

          salePrice

        );





        if(sale.type){



          const type =

            document.createElement(

              'span'

            );





          type.className =

            'az-sale-type';





          type.textContent =

            sale.type;





          left.appendChild(

            type

          );



        }





        const date =

          document.createElement(

            'span'

          );





        date.className =

          'az-sale-date';





        date.textContent =

          formatDate(

            sale.date

          );





        row.appendChild(

          left

        );





        row.appendChild(

          date

        );





        recentSales.appendChild(

          row

        );



      });





    /* =======================================================

       LAST UPDATED

    ======================================================= */



    lastUpdated.textContent =

      formatDate(

        sales[0].date

      );





    /* =======================================================

       PRICE HISTORY

    ======================================================= */



    const chartSales =

      sales.filter(

        function(sale){



          return (

            Number.isFinite(

              Number(sale.price)

            ) &&

            dateTimestamp(

              sale.date

            ) > 0

          );



        }

      );





    if(

      chartSales.length >= 2

    ){



      priceHistoryEmpty.hidden =

        true;





      priceChart.hidden =

        false;





      renderPriceChart(

        chartSales

      );



    }else{



      priceHistoryEmpty.hidden =

        false;





      priceChart.hidden =

        true;





      const historyTitle =

        priceHistoryEmpty.querySelector(

          'strong'

        );





      const historyCopy =

        priceHistoryEmpty.querySelector(

          'p'

        );





      if(historyTitle){



        historyTitle.textContent =

          'One verified sale recorded';



      }





      if(historyCopy){



        historyCopy.textContent =

          'One more verified sale is needed before a price history chart can be shown.';



      }



    }



  }





  /* =========================================================

     OPEN CARD

  ========================================================= */



  function openCard(card){



    const json =

      card.querySelector(

        '.az-card-data'

      );





    if(!json){

      return;

    }





    const data =

      JSON.parse(

        json.textContent

      );

    azActiveCardData = data;





    currentCardToken++;





    const token =

      currentCardToken;





    /* CARD DETAILS */



    document

      .getElementById(

        'az-modal-name'

      )

      .textContent =

        data.name || '';





    document

      .getElementById(

        'az-modal-game'

      )

      .textContent =

        (data.game || '') +

        ' · ' +

        (data.set || '');





    document

      .getElementById(

        'az-modal-number'

      )

      .textContent =

        data.number || '';





    document

      .getElementById(

        'az-modal-rarity'

      )

      .textContent =

        data.rarity || '—';





    document

      .getElementById(

        'az-modal-variant'

      )

      .textContent =

        data.variant || 'Normal';





    document

      .getElementById(

        'az-modal-language'

      )

      .textContent =

        data.language || '—';





    document

      .getElementById(

        'az-modal-set'

      )

      .textContent =

        data.set || '—';





    /* MARKET */



    renderMarketData(

      data

    );





    /* =======================================================

       IMAGE

    ======================================================= */



    modalImage.removeAttribute(

      'src'

    );





    modalImage.alt =

      data.name || '';





    modalImage.style.opacity =

      '0';





    modalImage.style.display =

      'none';





    imageLoader

      .classList

      .add(

        'is-loading'

      );





    if(data.thumbnail){



      const thumb =

        new Image();





      thumb.onload =

        function(){



          if(

            token !==

            currentCardToken

          ){

            return;

          }





          modalImage.src =

            data.thumbnail;





          modalImage.style.display =

            'block';





          requestAnimationFrame(

            function(){



              modalImage.style.opacity =

                '1';



            }

          );



        };





      thumb.src =

        data.thumbnail;



    }





    if(data.image){



      const hdImage =

        new Image();





      hdImage.onload =

        function(){



          if(

            token !==

            currentCardToken

          ){

            return;

          }





          modalImage.src =

            data.image;





          modalImage.style.display =

            'block';





          modalImage.style.opacity =

            '1';





          imageLoader

            .classList

            .remove(

              'is-loading'

            );



        };





      hdImage.onerror =

        function(){



          if(

            token !==

            currentCardToken

          ){

            return;

          }





          imageLoader

            .classList

            .remove(

              'is-loading'

            );



        };





      hdImage.src =

        data.image;



    }else{



      imageLoader

        .classList

        .remove(

          'is-loading'

        );



    }





    /* OPEN */



    storedScrollY =

      window.scrollY ||

      window.pageYOffset ||

      0;





    modal.classList.add(

      'az-open'

    );





    modal.setAttribute(

      'aria-hidden',

      'false'

    );





    document

      .documentElement

      .classList

      .add(

        'az-modal-open'

      );





    document

      .body

      .classList

      .add(

        'az-modal-open'

      );





    modalPanel.scrollTop =

      0;



  }





  /* =========================================================

     CLOSE MODAL

  ========================================================= */



  function closeModal(){
azActiveCardData = null;


    currentCardToken++;





    modal.classList.remove(

      'az-open'

    );





    modal.setAttribute(

      'aria-hidden',

      'true'

    );





    document

      .documentElement

      .classList

      .remove(

        'az-modal-open'

      );





    document

      .body

      .classList

      .remove(

        'az-modal-open'

      );





    modalImage.removeAttribute(

      'src'

    );





    modalImage.style.display =

      'none';





    modalImage.style.opacity =

      '0';





    imageLoader

      .classList

      .remove(

        'is-loading'

      );





    requestAnimationFrame(

      function(){



        window.scrollTo(

          0,

          storedScrollY

        );



      }

    );



  }





  const closeButton =

    document.getElementById(

      'az-modal-close'

    );





  if(closeButton){



    closeButton.addEventListener(

      'click',

      closeModal

    );



  }





  const overlay =

    modal.querySelector(

      '.az-modal-overlay'

    );





  if(overlay){



    overlay.addEventListener(

      'click',

      closeModal

    );



  }





  document.addEventListener(

    'keydown',

    function(e){



      if(

        e.key === 'Escape' &&

        modal.classList.contains(

          'az-open'

        )

      ){



        closeModal();



      }



    }

  );





  /* =========================================================

     FILTER EVENTS

  ========================================================= */



  [

    search,

    gameFilter,

    setFilter,

    rarityFilter

  ].forEach(function(el){



    if(!el){

      return;

    }





    el.addEventListener(



      el.tagName === 'INPUT'

        ? 'input'

        : 'change',



      function(){



        if(

          el === search &&

          heroSearch

        ){



          heroSearch.value =

            search.value;



        }





        runFilters();



      }



    );



  });





  /* =========================================================

     LOAD ALL SHOPIFY CARD PAGES

  ========================================================= */



  async function loadRemainingPages(){



    azSetLoaderStatus('Preparing card database...');



    let nextUrl =

      database.dataset.nextUrl;





    grid.style.visibility =

      'hidden';





    if(counter){



      counter.textContent =

        'Loading cards...';



    }





    while(nextUrl){



      try{



        const response =

          await fetch(

            nextUrl

          );





        if(!response.ok){



          throw new Error(

            'HTTP ' +

            response.status

          );



        }





        const html =

          await response.text();





        const parser =

          new DOMParser();





        const doc =

          parser.parseFromString(

            html,

            'text/html'

          );





        const nextDatabase =

          doc.querySelector(

            '#az-card-database'

          );





        if(!nextDatabase){



          break;



        }





        const newCards =

          nextDatabase

            .querySelectorAll(

              '.az-card-item'

            );





        newCards.forEach(

          function(card){



            grid.appendChild(

              document.importNode(

                card,

                true

              )

            );



          }

        );





        nextUrl =

          nextDatabase.dataset.nextUrl;



      }catch(error){



        console.error(

          'AZ TCG pagination error:',

          error

        );





        break;



      }



    }





    refreshCards();



    runFilters();





    grid.style.visibility =

      'visible';



  }





 /* =========================================================
   START
========================================================= */

azSetCardPriceState('loading');

loadRemainingPages()
  .then(function() {

    // All card pages are now available.
    // Keep displaying LOADING while sales data is fetched.
    azSetCardPriceState('loading');

    return loadVerifiedTransactions();

  })
  .then(function() {

    // Prices have been calculated.
    // Refresh the open modal if the customer
    // clicked a card while transactions were loading.
    if (modal.classList.contains('az-open') && azActiveCardData) {
      renderMarketData(azActiveCardData);
    }

    window.requestAnimationFrame(function() {
      window.requestAnimationFrame(azDismissLoader);
    });

  })
  .catch(function(error) {

    console.error('AZ TCG loading error:', error);

    if (azTransactionsState !== 'ready') {
      azTransactionsState = 'error';
      azSetCardPriceState('error');
    }

    if (modal.classList.contains('az-open') && azActiveCardData) {
      renderMarketData(azActiveCardData);
    }

    grid.style.visibility = 'visible';

    azDismissLoader();

  })
  .finally(function() {

    window.clearTimeout(azLoaderLongWait);

  });

});